module.exports = __webpack_public_path__ + "static/media/uae.61421a23.jpg";